var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{attrs:{"id":"container"}}),_c('span',{staticClass:"text-warning"},[_vm._v(" 可拖动放大")])])
}]

export { render, staticRenderFns }